import React from 'react';

/** Layered waves like a sari border: saffron, rani pink, indigo. `to` = next section background. */
export function Waves({
  to = '#FFFFFF',
  className = ''
}: {
  to?: string;
  className?: string;
}) {
  return <svg aria-hidden="true" viewBox="0 0 1440 160" preserveAspectRatio="none" className={`block h-[80px] w-full sm:h-[130px] ${className}`} data-id="element-359" data-mp="oifi5ynfqor1">
      <path d="M0 90 C 200 30, 380 140, 620 80 S 1040 20, 1440 70 L1440 160 L0 160Z" fill="#F5A524" data-id="element-360" data-mp="xhsgbv63zqwg" />
      <path d="M0 110 C 240 60, 420 150, 700 105 S 1120 60, 1440 100 L1440 160 L0 160Z" fill="#D62E80" data-id="element-361" data-mp="sj7q8okkmnlq" />
      <path d="M0 128 C 260 98, 520 160, 800 126 S 1200 102, 1440 122 L1440 160 L0 160Z" fill="#3B3BA8" data-id="element-362" data-mp="17grs3mm682no" />
      <path d="M0 146 C 300 130, 600 160, 900 144 S 1260 136, 1440 144 L1440 160 L0 160Z" fill={to} data-id="element-363" data-mp="12glt1ldkndvk" />
    </svg>;
}